import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage } from '@divvy-web/i18n'

import useGetCreditAppTypes from '@sputnik/hooks/useGetCreditAppTypes'
import CreditApplicationPageLayout from '@sputnik/pages/CreditApplicationPages/CreditApplicationPageLayout'
import { PATHNAME_CONSTS } from '@sputnik/resources/constants'
import { useWebTracking } from '@sputnik/tracking/WebTrackingContext'

import AuthorizedSignerSection from './AuthorizedSignerSection'
import CompanyOwnerSection from './CompanyOwnerSection'
import OutsourcedAccountantSection from './OutsourcedAccountantSection'
import PeopleInfoFormMarketingContent from './PeopleInfoFormMarketingContent'
import styles from './styles.module.scss'

const PeopleInfoForm = () => {
  const { appId } = useParams()
  const [getClassName] = useNameFormatter('PeopleInfoForm')
  const { isMajorAccountChange, isMigration } = useGetCreditAppTypes({ salesforceCreditId: appId ?? '' })

  const navigate = useNavigate()

  /* tracking start */

  const { tracker } = useWebTracking()

  useEffect(() => {
    tracker?.track('se_signup__people_info__presented')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  /* tracking end */

  const onBackClick = () => {
    tracker?.track('se_signup__application_people_info_back__fired')
    if (isMigration || isMajorAccountChange) {
      navigate(`../${PATHNAME_CONSTS.BUSINESS_ADDRESS_PATH}`)
      return
    }

    navigate(`../${PATHNAME_CONSTS.CONNECT_BANK_ACCOUNT_PATH}`)
  }

  const onNextClick = () => {
    tracker?.track('se_signup__application_people_info_next__fired')
    navigate(`../${PATHNAME_CONSTS.REVIEW_PATH}`)
  }

  return (
    <div className={styles[getClassName('')]}>
      <CreditApplicationPageLayout
        marketing={<PeopleInfoFormMarketingContent />}
        pageTitle={
          <FormattedMessage
            defaultMessage='Add people'
            id='sputnik.PeopleInfoForm__nameAndOwnership'
          />
        }
        onBackClick={onBackClick}
        onNextClick={onNextClick}
      >
        <AuthorizedSignerSection />
        <CompanyOwnerSection />
        <OutsourcedAccountantSection />
      </CreditApplicationPageLayout>
    </div>
  )
}

export default PeopleInfoForm
